// changeShowcaseSize.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
import {
  showcaseContainerGap,
  showcaseItemGap,
  showcaseMobileWidth,
  showcaseMobileHeight,
  showcaseTabletWidth,
  showcaseTabletHeight,
  showcaseDesktopWidth,
  showcaseDesktopHeight,
  showcaseMobileMinimumItemAmount,
  showcaseDesktopMinimumItemAmount,
} from '../style/variables.js';
import { breakpoint } from '../style/variables.js';

const isClient = typeof window !== 'undefined';

/**
 * calculate showcase item amount.
 * @param {number} itemAmount - showcase item amount.
 * @param {number} itemWidth - showcase item width.
 * @returns {number} return showcase item amount.
 */
export const getItemAmount = ({ screenWidth, itemWidth }) => {
  const containerWidth = screenWidth - showcaseContainerGap;
  const itemWidthWithGap = itemWidth + showcaseItemGap;
  const itemAmount = Math.max(
    Math.ceil(containerWidth / itemWidthWithGap),
    showcaseMobileMinimumItemAmount
  );
  const isEven = itemAmount % 2 === 0;

  if (isEven) {
    return itemAmount + 3;
  }

  return itemAmount + 2;
};

/**
 * Change showcase size
 * @kind action
 * @return {Promise} Action promise.
 */
const changeShowcaseSize = () => async dispatch => {
  const screenWidth = isClient
    ? document.body.getBoundingClientRect().width
    : 0;
  const isMobile = screenWidth <= breakpoint.mobile;
  const isTablet =
    screenWidth > breakpoint.mobile && screenWidth <= breakpoint.tablet;

  let itemWidth = isMobile
    ? showcaseMobileWidth
    : isTablet
      ? showcaseTabletWidth
      : showcaseDesktopWidth;
  let itemHeight = isMobile
    ? showcaseMobileHeight
    : isTablet
      ? showcaseTabletHeight
      : showcaseDesktopHeight;
  let itemAmount = getItemAmount({ screenWidth, itemWidth });

  if (isMobile) {
    itemAmount = Math.max(itemAmount, showcaseMobileMinimumItemAmount);
  } else {
    itemAmount = Math.max(itemAmount, showcaseDesktopMinimumItemAmount);
  }

  return dispatch({
    type: MERGE_OPERATION_DATA,
    payload: {
      selectPath: ['showcase'],
      data: {
        itemAmount,
        itemWidth,
        itemHeight,
      },
    },
  });
};

export default changeShowcaseSize;
